import type { RefundRow } from "../types";

/** 管理列表与状态筛选共用的审核状态名称。 */
export const refundStatusLabels: Record<RefundRow["status"], string> = {
  pending: "待审核", approved: "已通过", rejected: "已驳回",
};
